export const NumFourCircleIcon = () => {
    return (
        <svg width="100%" height="100%" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="20" cy="20.5791" r="18.6667" stroke="url(#paint0_linear_971_23862)" strokeWidth="2.66667"/>
            <path
                d="M24.576 30.5791H21.66V27.5311H13.2V24.8191L18.804 13.2991H21.996L16.38 24.8191H21.66V19.4191H24.576V24.8191H26.256V27.5311H24.576V30.5791Z"
                fill="url(#paint1_linear_971_23862)"/>
            <defs>
                <linearGradient id="paint0_linear_971_23862" x1="22.7586" y1="-21.7738" x2="77.5901" y2="63.8423"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
                <linearGradient id="paint1_linear_971_23862" x1="21.1034" y1="-11.7444" x2="66.8186" y2="25.0977"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
            </defs>
        </svg>
    );
};